import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import downloadbuttonres1 from "../assets/images/download_button.png";
import downloadbuttonres2 from "../assets/images/download_button2.png";
import Vectornew from "../assets/images/Vector-new.png";
import backgroundrestsec from "../assets/images/bg-app.png";
import module from "../assets/images/moudle_res.png";
import "./Registration.css";

export default function Registration() {
  return (
    <>
      <Header />

      <div
        className="registration_outer"
        style={{ backgroundImage: `url(${backgroundrestsec})` }}
      >
        <div
          className="for_vector_back"
          style={{ backgroundImage: `url(${Vectornew})` }}
        ></div>
        <div className="container-fluid">
          <div className="registration_inner">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <div className="rest_text_sec">
                  <span>Download the CareAtHome App</span>
                  <h1>
                    Trusted by Thousands of Families for Reliable Home
                    Healthcare Services.
                  </h1>
                  <p>
                    Access trusted healthcare services anytime, anywhere. Book
                    doctors, nursing care, physiotherapy, lab tests, medicines,
                    and home care services with just a few taps. Experience
                    seamless healthcare management from the comfort of your
                    home.
                  </p>
                  <div className="downd_btnss">
                    <Link
                      to="https://play.google.com/store/search?q=Caresathome&c=apps&hl=en_IN"
                      target="_blank"
                    >
                      <img src={downloadbuttonres1} alt="downloadbutton-1" />
                    </Link>
                    <Link
                      to="https://play.google.com/store/search?q=Caresathome&c=apps&hl=en_IN"
                      target="_blank"
                    >
                      <img src={downloadbuttonres2} alt="downloadbutton-2" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12 ">
                <div className="rest_img_sec">
                  <img src={module} alt="module" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="registration-process-outer">
        <div className="container-fluid">
          <div className="registeration-heading">
            <h2>
              CaresAtHome <span>Partner Registration</span> — Steps
            </h2>
            <p>
              Follow a few simple steps to register as a CaresAtHome Partner and
              start offering your healthcare services.
            </p>
          </div>
        </div>

        <div class="partner-process">
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">1.</span>
              <h3>Login In / Register Yourself</h3>
              <p>
                Existing partners log in with mobile number and password; new
                partners sign up with mobile number and OTP verification.
              </p>
            </div>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">2.</span>
              <h3>Select Your Primary Service</h3>
              <p>
                Choose Caregiver (Nursing, Physiotherapy, Bedside Attendant) or
                Doctor Consultant (Video Call, At Clinic, At Home).
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">3.</span>
              <h3>Tell Us About Yourself</h3>
              <p>
                Add personal details: name, phone, email, state, city, address,
                pincode, gender, education, and experience.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">4.</span>
              <h3>Service, Fee & Availability</h3>
              <p>
                Select your service, set your fee and availability (days & time
                slots), then submit.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">5.</span>
              <h3>Registration Successfully</h3>
              <p>
                Your profile is under review; once verified, you get access to
                your dashboard and start receiving patient requests.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
        </div>
      </div>

      <div className="registration-process-outer registration-process-outer-2">
        <div className="container-fluid">
          <div className="registeration-heading">
            <h2>
              {" "}
              CaresAtHome <span>Doctor Consultant</span> — Steps
            </h2>
            <p>
              Follow a few simple steps to register as a CaresAtHome Partner and
              start offering your healthcare services.
            </p>
          </div>
        </div>

        <div class="partner-process">
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">1.</span>
              <h3>Login In / Register Yourself</h3>
              <p>
                Existing doctors log in with mobile number and password; new
                doctors sign up with mobile number and OTP verification.
              </p>
            </div>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">2.</span>
              <h3>Select Your Primary Service</h3>
              <p>
                Choose Doctor Consultant, specifying consultation mode (Online
                Video Call, At Clinic, At Home).
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">3.</span>
              <h3>Tell Us About Yourself</h3>
              <p>
                Add personal details: name, phone, email, state, city, address,
                pincode, gender, education, and experience.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">4.</span>
              <h3>Choose Your Medical Expertis</h3>
              <p>
                Select your specialty, consultation mode, and fee; set your
                availability (days & time slots), then submit.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">5.</span>
              <h3>Registration Successfully</h3>
              <p>
                Your profile is under review; once verified, you get access to
                your dashboard and start receiving patient consultations.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
